import fetch from '../../fetch';
import { IHttpMethod, ServicesURL } from '../../../ts/enums/fetch-enums';

const endpoints = {
  status: 'Web3Consent/status',
  accept: 'Web3Consent/accept',
};

export interface IWeb3ConsentTerm {
  id: number;
  version: number;
  content: string;
  createdAt: string;
}

export interface IWeb3ConsentStatus {
  accepted: boolean;
  term: IWeb3ConsentTerm | null;
}

export async function getWeb3ConsentStatus(): Promise<IWeb3ConsentStatus> {
  const { data } = await fetch({
    method: IHttpMethod.GET,
    path: endpoints.status,
    service: ServicesURL.CRYPTOCRONTROL,
  });

  return data;
}

export async function acceptWeb3Consent(termId: number): Promise<void> {
  await fetch({
    method: IHttpMethod.POST,
    path: endpoints.accept,
    data: { termId },
    service: ServicesURL.CRYPTOCRONTROL,
  });
}
